import { ACTION } from './onboarding-process.js'

function onboardingReducer(state, action) {
  switch (action.type) {
    case ACTION.UPDATE_PURPOSE_OF_ONBOARDING_LIST:
      return (state = {
        ...state,
        purposeOfOnboarding: action.payload.purposeOfOnboarding
      })
    case ACTION.UPDATE_GOALS_LIST:
      return (state = {
        ...state,
        goals: action.payload.goals
      })
    default:
      return state
  }
}

export default onboardingReducer
